import axiosInstance from './axiosConfig';
import { apis } from './params';

/**
 * Service to fetch all dynamic pricing mappings with pagination.
 * @param _params Query parameters (page, size)
 */
export function getDynamicPricingListService(_params: string) {
    return axiosInstance({
        "method": "Get",
        "url": apis.GET_DYNAMIC_PRICING_LIST + (_params ? `?${_params}` : "")
    });
}

/**
 * Service to fetch a single dynamic pricing mapping by MSN.
 * @param msn Product Reference
 */
export function getDynamicPricingByIdService(msn: string) {
    return axiosInstance({
        "method": "Get",
        "url": apis.GET_DYNAMIC_PRICING_BY_ID + msn
    });
}

/**
 * Service to create a new dynamic pricing mapping.
 * @param _body Mapping details
 */
export function createDynamicPricingService(_body: any) {
    return axiosInstance({
        "method": "Post",
        "url": apis.CREATE_DYNAMIC_PRICING,
        "data": _body
    });
}

/**
 * Service to update an existing dynamic pricing mapping.
 * @param _body Updated mapping details
 */
export function updateDynamicPricingService(_body: any) {
    return axiosInstance({
        "method": "Put",
        "url": apis.UPDATE_DYNAMIC_PRICING,
        "data": _body
    });
}

/**
 * Service to delete a dynamic pricing mapping by MSN.
 * @param msn Product Reference
 */
export function deleteDynamicPricingService(msn: string) {
    return axiosInstance({
        "method": "Delete",
        "url": apis.DELETE_DYNAMIC_PRICING + msn
    });
}

/**
 * Service to get filter options for dynamic pricing.
 * @param _body Filter criteria
 */
export function getDynamicPricingFiltersService(_body: any) {
    return axiosInstance({
        "method": "Post",
        "url": apis.GET_DYNAMIC_PRICING_FILTERS,
        "data": _body
    });
}

/**
 * Service to search dynamic pricing mappings.
 * @param _body Search criteria with pagination
 */
export function searchDynamicPricingService(_body: any) {
    return axiosInstance({
        "method": "Post",
        "url": apis.SEARCH_DYNAMIC_PRICING,
        "data": _body
    });
}

/**
 * Service to bulk upload dynamic pricing mappings.
 * @param _formData FormData object containing file and emailId
 */
export function bulkUploadDynamicPricingService(_formData: FormData) {
    return axiosInstance({
        "method": "Post",
        "url": apis.BULK_UPLOAD_DYNAMIC_PRICING,
        "data": _formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

/**
 * Service to trigger synchronization of Dynamic Pricing metadata.
 */
export function syncDpMetaService() {
    return axiosInstance({
        "method": "Post",
        "url": apis.SYNC_DP_META,
        "data": {}
    });
}

/**
 * Service to get the history of dynamic pricing updates within a date range.
 * @param startDate The start date for the filter (e.g. 2026-09-15 15:05:45)
 * @param endDate The end date for the filter (e.g. 2026-09-16 15:06:45)
 */
export function getDynamicPricingHistoryService(startDate: string, endDate: string) {
    return axiosInstance({
        "method": "Get",
        "url": `${apis.GET_DYNAMIC_PRICING_HISTORY}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
    });
}
